import {
  VALIDATE_OBJECT,
  VALIDATE_REQUIRED_STRING,
  VALIDATE_STRING_OF_NUMBERS,
  Yup,
} from '@validations';
import {
  useGetCitiesByProvince,
  useProvinceFromArgentine,
} from '@modules/clients/data/PlacesRepository';

export const ERROR_AT_LEAST_ONE_FIELD = 'COMMON:VALIDATIONS:AT_LEAST_ONE_FIELD_REQUIRED';

export const validationSchema = VALIDATE_OBJECT({
  cuit: VALIDATE_STRING_OF_NUMBERS.min(9, 'COMMON:VALIDATIONS:CUIT_INVALID_LENGTH')
    .max(12, 'COMMON:VALIDATIONS:CUIT_INVALID_LENGTH')
    .required('COMMON:VALIDATIONS:REQUIRED_FIELD')
    .trim(),
  companyName: VALIDATE_REQUIRED_STRING.trim().max(40, 'COMMON:VALIDATIONS:COMPANY_NAME_LENGTH'),
  companyGroup: Yup.mixed(),
  customerType: Yup.mixed().required('COMMON:VALIDATIONS:REQUIRED_FIELD'),
  segment: VALIDATE_REQUIRED_STRING.trim(),
  city: Yup.mixed().required('COMMON:VALIDATIONS:REQUIRED_FIELD'),
  street: VALIDATE_REQUIRED_STRING.max(100, 'COMMON:VALIDATIONS:INVALID_LENGTH').required(
    'COMMON:VALIDATIONS:REQUIRED_FIELD'
  ),
  number: VALIDATE_STRING_OF_NUMBERS.max(10, 'COMMON:VALIDATIONS:INVALID_LENGTH').required(
    'COMMON:VALIDATIONS:REQUIRED_FIELD'
  ),
  floor: VALIDATE_STRING_OF_NUMBERS.max(10, 'COMMON:VALIDATIONS:INVALID_LENGTH'),
  apartment: VALIDATE_STRING_OF_NUMBERS.max(8, 'COMMON:VALIDATIONS:INVALID_LENGTH').matches(
    /^[a-zA-Z0-9]+$/,
    'COMMON:VALIDATIONS:ONLY_NUMBERS_AND_LETTERS'
  ),
  postalCode: VALIDATE_STRING_OF_NUMBERS.max(20, 'COMMON:VALIDATIONS:INVALID_LENGTH').required(
    'COMMON:VALIDATIONS:REQUIRED_FIELD'
  ),
});

export const FIELDS = [
  { name: 'cuit', label: 'COMMON:CUIT', type: 'input' },
  { name: 'companyName', label: 'COMMON:COMPANY_NAME', type: 'input' },
  { name: 'companyGroup', label: 'COMMON:COMPANY_GROUP', type: 'autocomplete' },
  { name: 'customerType', label: 'COMMON:CUSTOMER_TYPE', type: 'autocomplete' },
  { name: 'segment', label: 'COMMON:SEGMENT', type: 'input' },
];

export const FIELDS_ADDRESS = [
  {
    name: 'province',
    label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:STATE',
    type: 'selectFetch',
    getOptions: useProvinceFromArgentine,
  },
  {
    name: 'city',
    label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:CITY',
    type: 'AutocompleteComplexFetch',
    getOptions: useGetCitiesByProvince,
    parseOption: ({ id, name }) => ({ id: id, title: name }),
    disabled: (values) => !values['province'],
  },
  {
    name: 'street',
    label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:STREET',
    type: 'input',
  },
  {
    name: 'number',
    label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:NUMBER',
    type: 'input',
  },
  {
    name: 'floor',
    label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:FLOOR',
    type: 'input',
  },
  {
    name: 'apartment',
    label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:APARMENT',
    type: 'input',
  },
  {
    name: 'postalCode',
    label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:POSTAL_CODE',
    type: 'input',
  },
];

export const CUSTOMER_TYPES = [
  { value: 'PUBLIC', label: 'Público' },
  { value: 'PRIVATE', label: 'Privado' },
];
